/**
 * Requires
 */

import $ from 'jquery'

const mediaXS = window.matchMedia('(max-width: 639px)')
const mediaS = window.matchMedia('(min-width: 640px) and (max-width: 959px)')
let eventList = Array.from(document.querySelectorAll('[data-ajax-form-target="events"] .columns > .column'))

/**
 * Initialisation
 */

export function initialise() {
  if (eventList) {
    mediaXS.matches && sortColumns(eventList, 2, { null: 1, small: 2, large: 2 })
    mediaS.matches && sortColumns(eventList, 2, { null: 1, small: 1, large: 2 })
  }
  // if event reorder.event is fired, then reorder events
  $(document).on('reorder.events', function() {
    eventList = Array.from(document.querySelectorAll('[data-ajax-form-target="events"] .columns > .column'))
    mediaXS.matches && sortColumns(eventList, 2, { null: 1, small: 2, large: 2 })
    mediaS.matches && sortColumns(eventList, 2, { null: 1, small: 1, large: 2 })
  })
}

function sortColumns(
  items,
  columns = 4,
  getFeaturedSize = {
    null: 1,
    small: 2,
    large: 4,
  }
) {
  if (!items || items.length === 0) return []

  const sortedItems = []
  let pendingItems = []
  let remainingSpace = columns

  items.forEach(item => {
    if (remainingSpace === 0) remainingSpace = columns
    // get featured size from data-featured attribute
    const featured_value = item.getAttribute('data-featured') || null
    const featuredSize = getFeaturedSize[featured_value]
    const updateColumns = mediaXS.matches && featuredSize !== columns

    if (pendingItems.length) {
      pendingItems.forEach((pendingItem, pendingIndex) => {
        const featured_value = pendingItem.getAttribute('data-featured') || null
        const featuredSize = getFeaturedSize[featured_value]
        const columnInner = $(pendingItem).children('.column-inner')

        if (remainingSpace >= featuredSize) {
          $(pendingItem).css('order', sortedItems.length + 1)
          if (updateColumns && remainingSpace !== featuredSize) {
            columnInner.css('margin-right', '0.5rem')
          } else if (updateColumns && remainingSpace === featuredSize) {
            columnInner.css('margin-left', '0.5rem')
          }
          console.log($(pendingItem).children('.column-inner'))
          remainingSpace -= featuredSize
          pendingItems.splice(pendingIndex, 1)
          sortedItems.push(pendingItem)
        }
      })
    }

    if (remainingSpace >= featuredSize) {
      $(item).css('order', sortedItems.length + 1)
      const columnInner = $(item).children('.column-inner')

      if (updateColumns && remainingSpace !== featuredSize) {
        columnInner.css('margin-right', '0.5rem')
      } else if (updateColumns && remainingSpace === featuredSize) {
        columnInner.css('margin-left', '0.5rem')
      }
      remainingSpace -= featuredSize
      sortedItems.push(item)
    } else {
      pendingItems.push(item)
    }
  })

  if (pendingItems.length) {
    $(...pendingItems).css('order', sortedItems.length + 1)
    sortedItems.push(...pendingItems)
  }

  return sortedItems
}
